module.exports = __webpack_public_path__ + "static/home-hero@2x-07e70e569f10370f7fc7835f83d9e996.jpg";